import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_CLIENT_PUBLIC_NOTES: string = typeCreatorV2(
  'ClientNotesReducer',
  'SetClientPublicNotes'
);

export const CREATE_PUBLIC_NOTE: string = typeCreatorV2(
  'ClientNotesReducer',
  'CreatePublicNote'
);

export const DELETE_PUBLIC_NOTE: string = typeCreatorV2(
  'ClientNotesReducer',
  'DeletePublicNote'
);
